<template>
    <div class="shop">
        <div v-if="1 == isRegrster">
            <div class="shop-form">
                <van-form @submit="submitUserData">
                  <div class="shop-form-remark" v-if="id">
                    <span>审核不通过，驳回理由：{{ applyRemark }}</span>
                  </div>
                    <div class="shop-form-title">一、个人基础信息</div>
                    <div class="shop-form-count">
                        <div class="shop-form-count-label">姓名</div>
                        <!-- :rules="[{ required: true, message: '请输入店老板姓名' }]" -->
                        <div class="shop-form-field">
                          <van-field
                            name="userName"
                            v-model="fieldForm.userName"
                            placeholder="请输入称呼"
                            input-align="left"
                            clearable
                            error-message-align="left"
                            style="width: 240px;"
                            @blur="onFieldBlur('userName', fieldForm.userName)"
                            type="text"
                          />
                        </div>
                    </div><div class="shop-form-line"></div>
                    <div class="shop-form-count">
                      <div class="shop-form-count-label">年龄</div>
                      <div class="shop-form-field">
                          <van-field
                            name="age"
                            v-model="fieldForm.age"
                            placeholder="岁数"
                            input-align="left"
                            clearable
                            error-message-align="left"
                            style="width: 240px;"
                            @blur="onFieldBlur('age', fieldForm.age)"
                            type="digit"
                          />
                      </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-count">
                        <div class="shop-form-count-label">手机号</div>
                        <div class="shop-form-field">
                            <van-field
                                name="phone"
                                v-model="fieldForm.phone"
                                placeholder="可用于登录吉祥有约"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                clearable
                                type="tel"
                                :maxlength="11"
                                @update:model-value="verifyStore(fieldForm.phone)"
                                @blur="onFieldBlur('phone', fieldForm.phone)"
                            />
                        </div>
                    </div>
                    <div class="shop-form-count">
                        <div class="shop-form-count-label">验证码</div>
                        <div class="shop-form-field">
                            <van-field
                                name="smsCode"
                                v-model="smsCode"
                                clearable
                                :maxlength="6"
                                label=""
                                type="tel"
                                input-align="left"
                                error-message-align="left"
                                placeholder="请输入短信验证码"
                                @blur="onFieldBlur('smsCode', smsCode)"
                            >
                                <template #button>
                                    <div class="sms-btn btn-maker" @click="getMsgCode(fieldForm.phone)">{{ smsCodeText }}</div>
                                </template>
                            </van-field>
                        </div>
                    </div>
                    <div class="sms-code-tip" v-show="smsCode">
                        <img class="sms-tip-img" :src="require(smsCode.length === 6 && msgCodeStatus ? '../../assets/suc.png' : '../../assets/err.png')" />
                        <text :class="smsCode.length === 6 && msgCodeStatus ? 'suc-tip' : 'err-tip'">{{ smsCode.length === 6 && msgCodeStatus ? '手机号验证通过，请继续往下填写吧' : '验证码有误请重新输入' }}</text>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">身份证件照(正面)</span>
                      </div>
                      <div class="shop-form-upload-tip">证件正面（人脸），仅用于平台创客入驻资料审核认证</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="idCardFront"
                          v-model="idCardFront"
                          preview-size="50"
                          :max-count="1"
                          :before-delete="delIdCardFront"
                          :after-read="idCardFrontAfterUpload"
                          multiple
                        />
                      </div>
                    </div>

                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">身份证件照(反面)</span>
                      </div>
                      <div class="shop-form-upload-tip">证件反面（国徽），仅用于平台创客入驻资料审核认证</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="idCardBack"
                          v-model="idCardBack"
                          preview-size="50"
                          :max-count="1"
                          :before-delete="delIdCardBack"
                          :after-read="idCardBackAfterUpload"
                          multiple
                        />
                      </div>
                    </div>

                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">个人形象照</span>
                      </div>
                      <div class="shop-form-upload-tip">用于平台个人名片形象展示</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="userImage"
                          v-model="userImage"
                          preview-size="50"
                          :max-count="100"
                          :before-delete="delUserImage"
                          :after-read="userImageAfterUpload"
                          multiple
                        />
                      </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <div class="shop-form-count">
                        <div class="shop-form-count-label">常住详细地址</div>
                        <div class="shop-form-field field-full-address">
                            <van-field
                                name="userAddress"
                                v-model="fieldForm.userAddress"
                                clearable
                                placeholder="点击右侧图标选择地理位置"
                                input-align="left"
                                error-message-align="left"
                                style="width: 210px;"
                                @blur="onFieldBlur('userAddress', fieldForm.userAddress)"
                                type="textarea"
                            />
                            <img src="../../assets/position-icon.png" class="position-icon" alt="" @click="onShowMap">
                        </div>
                    </div>
                    <div class="shop-form-line"></div>

                    <!-- <div class="shop-form-count">
                        <div class="shop-form-count-label">经纬度</div>
                        <div class="shop-form-field" :class="fieldForm.position ? 'field-full-address' : ''">
                            <van-field
                                v-model="fieldForm.position"
                                clearable
                                placeholder="(填好地址系统自动获取)"
                                input-align="left"
                                error-message-align="left"
                                style="width: 240px;"
                                :disabled="true"
                            />
                        </div>
                    </div> -->
                    <!-- <div class="shop-form-line"></div> -->
                    <div class="shop-form-count shop-form-imgs">
                      <div class="shop-form-title" style="padding: 0; margin: 0;">二、创客入驻意向</div>
                      <div class="shop-form-count-checkbox">
                        <span class="count-checkbox">选择入驻角色（可多选）</span>
                      </div>
                      <!-- onFieldBlur('joinRole', makerRoles) -->
                      <van-checkbox-group
                        name="makerRoles"
                        v-model="makerRoles"
                        shape="square"
                        @change="onMakerRolesChange"
                      >
                        <van-checkbox
                          v-for=" (item, index) in roles"
                          :key="'role' + index"
                          :name="item.id"
                          style="margin-top: 8px;"
                        >{{ item.name }}</van-checkbox>
                      </van-checkbox-group>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-count shop-form-bolck">
                      <div class="shop-form-count-checkbox">
                        <span class="count-checkbox">可接受工作位置范围（可多选）</span>
                      </div>
                      <van-checkbox-group
                        name="scopeWork"
                        v-model="scopeWork"
                        shape="square"
                        @change="onScopeWorkChange"
                      >
                        <van-checkbox
                          v-for=" (item, index) in scopes"
                          :key="'scope' + index"
                          :name="item.id"
                          style="margin-top: 8px;"
                        >{{ item.name }}</van-checkbox>
                      </van-checkbox-group>
                    </div>

                    <div class="shop-form-count shop-form-imgs">
                      <div class="shop-form-title" style="padding: 0; margin: 12px 0 0 0;">三、职业能力评估</div>
                    </div>
                    <div class="shop-form-count">
                      <div class="shop-form-count-label shop-form-count-label-not">毕业院校</div>
                      <div class="shop-form-field">
                        <van-field
                          name="graduateSchool"
                          v-model="fieldForm.graduateSchool"
                          placeholder="最高学历毕业院校"
                          input-align="left"
                          clearable
                          error-message-align="left"
                          style="width: 260px;"
                          @blur="onFieldBlur('graduateSchool', fieldForm.graduateSchool)"
                          type="text"
                        />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-count">
                      <div class="shop-form-count-label shop-form-count-label-not">学习专业</div>
                      <div class="shop-form-field">
                        <van-field
                          name="professional"
                          v-model="fieldForm.professional"
                          placeholder="就读院校学习专业"
                          input-align="left"
                          clearable
                          error-message-align="left"
                          style="width: 260px;"
                          @blur="onFieldBlur('professional', fieldForm.professional)"
                          type="text"
                        />
                        </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload" style="margin-top: 12px;">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">从业经验（概述）</span>
                      </div>
                      <div class="shop-form-field" style="margin-left: 0;">
                          <van-field
                              name="workExperience"
                              v-model="fieldForm.workExperience"
                              rows="6"
                              autosize
                              type="textarea"
                              placeholder="请输入过往从业经验，清楚明了，最多500字..."
                              maxlength="500"
                              @blur="onFieldBlur('workExperience', fieldForm.workExperience)"
                          />
                      </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">从业经历照片</span>
                      </div>
                      <div class="shop-form-upload-tip">最多上传6张，用于平台创客入驻资格审核</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="workPicture"
                          v-model="workPicture"
                          preview-size="50"
                          :max-count="6"
                          :before-delete="delworkPicture"
                          :after-read="workPictureAfterUpload"
                          multiple
                        />
                      </div>
                    </div>
                    <div class="shop-form-line" style="margin-top: 12px;"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span">专业能力（概述）</span>
                      </div>
                      <div class="shop-form-field" style="margin-left: 0;">
                          <van-field
                              name="workAbility"
                              v-model="fieldForm.workAbility"
                              rows="6"
                              autosize
                              type="textarea"
                              placeholder="个人突出的专业能力是什么，最多300字..."
                              maxlength="300"
                              @blur="onFieldBlur('workAbility', fieldForm.workAbility)"
                          />
                      </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span shop-form-upload-label-not">技能证书</span>
                      </div>
                      <div class="shop-form-upload-tip">最多上传6张，用于平台创客入驻资格审核</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="workCertificate"
                          v-model="workCertificate"
                          preview-size="50"
                          :max-count="6"
                          :before-delete="delworkCertificate"
                          :after-read="workCertificateAfterUpload"
                          multiple
                        />
                      </div>
                    </div>
                    <div class="shop-form-line" style="margin-top: 12px;"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-not">过往服务案例成绩（概述）</span>
                      </div>
                      <div class="shop-form-field" style="margin-left: 0;">
                          <van-field
                              name="caseScore"
                              v-model="fieldForm.caseScore"
                              rows="6"
                              autosize
                              type="textarea"
                              placeholder="请输入过往服务案例，最多500字..."
                              maxlength="500"
                              @blur="onFieldBlur('caseScore', fieldForm.caseScore)"
                          />
                      </div>
                    </div>
                    <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span shop-form-upload-label-not">服务案例照片证明</span>
                      </div>
                      <div class="shop-form-upload-tip">最多上传6张，用于平台个人实力展示</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="casePhoto"
                          v-model="casePhoto"
                          preview-size="50"
                          :max-count="6"
                          :before-delete="delcasePhoto"
                          :after-read="casePhotoAfterUpload"
                          multiple
                        />
                      </div>
                    </div>
                    <!-- <div class="shop-form-line"></div>
                    <div class="shop-form-upload">
                      <div class="shop-form-upload-label">
                        <span class="shop-form-upload-label-span shop-form-upload-label-not">服务案例视频证明</span>
                      </div>
                      <div class="shop-form-upload-tip">用于平台创客入驻资格审核</div>
                      <div class="shop-form-upload-box">
                        <van-uploader
                          name="caseVideo"
                          v-model="caseVideo"
                          preview-size="50"
                          :max-count="6"
                          :before-delete="delCaseVideo"
                          :after-read="caseVideoAfterUpload"
                          multiple
                        />
                      </div>
                    </div> -->
                    <div class="shop-form-count shop-form-imgs">
                      <div class="shop-form-title" style="padding: 0; margin: 0;">四、声明及协议（必读并勾选确认）</div>
                      <div
                        class="xy-item"
                        v-for=" (item, index) in reference"
                        :key="'reference' + index"
                        @click="toggleCheckbox(item.id)"
                      >
                        <div class="xy-item-left" :class="{'xy-item-active': referenceCheck.length && referenceCheck.findIndex(item => item.id == item.id) != -1}">
                          <img v-if="referenceCheck.length && referenceCheck.findIndex(item => item.id == item.id) != -1" src="../../assets/maker/gou.png" alt="">
                        </div>
                        <div class="xy-item-right">{{ item.name }}</div>
                      </div>
                    </div>
                </van-form>
                <div class="shop-form-btn">
                  <div class="shop-form-btn-save" @click="submitUserData">确认提交入驻申请资料</div>
                </div>
            </div>
        </div>
        <div v-else class="c-success">
          <img src="../../assets/maker/create-success.png" alt="">
        </div>
        <div class="kf-body" ref="dragElement" @mousedown="startDrag" @touchstart="startDrag" :style="dragStyle">
            <img class="kf-body-btn" src="../../assets/maker/icon_qe.png" alt="客服">
        </div>
        <AppMap
          v-if="showMap"
          :lnglat="fieldForm.position ? fieldForm.position.join(',') : ''"
          :address="fieldForm.userAddress"
          @getMapInfo="getMapInfo"
        />
    </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import { isWeChat } from '@/utils/validate';
import img1 from "@/assets/settle/sha_01.jpg"
import img2 from "@/assets/settle/sha_02.jpg"
import img3 from "@/assets/settle/sha_03.jpg"
import img4 from "@/assets/settle/sha_04.jpg"
import img5 from "@/assets/settle/sha_05.jpg"
import suc from '@/assets/success.png'
import { useRouter } from "vue-router";
import { makerFieldForm } from './useHook/makerFieldForm'
import { useMsgCode } from './useHook/useMsgCode'
import AppMap from '../../components/app-map/index.vue'
export default {
    name: "MakerForm",
    data() {
        return
    },
    components: {
      AppMap
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const isWX = ref(isWeChat())
        const phone = ref('');
        const address = ref('')
        const smsCode = ref('') // 短信验证码
        const imgUrl = ref('https://image.jxt1314.com/h5')
        const pageScrollTop = ref(0)
        const idCardFront = ref([])
        const idCardBack = ref([])
        const userImage = ref([])
        const regesterPhone = ref('')
        const regesterCode = ref('')
        const regesterText = ref('获取验证码')
        const isSubSms = ref(false)
        const editAbled = ref(false)
        const successImg = ref(suc)
        const settleList = ref([
            { url: img1 },
            { url: img2 },
            { url: img3 },
            { url: img4 },
            { url: img5 },
        ])
        const showMap = ref(false)
        const $router = useRouter();
        // 添加拖动相关的状态
        const dragElement = ref(null);
        const dragStyle = ref({
            position: 'fixed',
            bottom: '170px',
            right: '0',
            cursor: 'move',
            zIndex: 999
        });
        let isDragging = false;
        let offsetX = 0;
        let offsetY = 0;
        let startTime = 0;
        let startX = 0;
        let startY = 0;
        // 添加客服按钮调用时间限制
        let lastServiceCallTime = 0;
        const SERVICE_CALL_INTERVAL = 1000; // 1秒间隔

        // 开始拖动
        const startDrag = (e) => {
            // 记录开始时间和位置，用于判断是否为点击
            startTime = new Date().getTime();
            startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
            startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;

            // 确保元素存在
            if (!dragElement.value) return;

            isDragging = false; // 先设置为false，只有实际移动时才设为true

            // 获取触摸点（兼容鼠标和触摸事件）
            const touch = e.type === 'touchstart' ? e.touches[0] : e;

            // 计算偏移量
            const rect = dragElement.value.getBoundingClientRect();
            offsetX = touch.clientX - rect.left;
            offsetY = touch.clientY - rect.top;

            // 添加事件监听
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('touchmove', onDrag, { passive: false });
            document.addEventListener('mouseup', handleDragEnd);
            document.addEventListener('touchend', handleDragEnd);
        };

        // 拖动中
        const onDrag = (e) => {
            // 阻止默认行为
            if (e.cancelable) {
                e.preventDefault();
            }

            isDragging = true;

            // 获取触摸点
            const touch = e.type === 'touchmove' ? e.touches[0] : e;

            // 获取视窗尺寸
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            // 获取元素尺寸
            const elementWidth = dragElement.value.offsetWidth;
            const elementHeight = dragElement.value.offsetHeight;

            // 计算新位置
            let newLeft = touch.clientX - offsetX;
            let newTop = touch.clientY - offsetY;

            // 边界限制：左侧和顶部保持在可视范围内
            newLeft = Math.max(0, newLeft);
            newTop = Math.max(0, Math.min(viewportHeight - elementHeight, newTop));

            // 右侧允许超出16像素
            newLeft = Math.min(viewportWidth - elementWidth + 16, newLeft);

            // 更新元素位置
            dragStyle.value.left = `${newLeft}px`;
            dragStyle.value.top = `${newTop}px`;
            // 移除bottom和right，避免冲突
            delete dragStyle.value.bottom;
            delete dragStyle.value.right;
        };

        // 处理拖动结束，包括判断是否为点击
        const handleDragEnd = (e) => {
            const endTime = new Date().getTime();
            const endX = e.type === 'touchend' ? (e.changedTouches ? e.changedTouches[0].clientX : startX) : e.clientX;
            const endY = e.type === 'touchend' ? (e.changedTouches ? e.changedTouches[0].clientY : startY) : e.clientY;

            const timeDiff = endTime - startTime;
            const distance = Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2));

            // 如果不是拖动（时间短且距离小），则触发客服功能
            if (!isDragging && timeDiff < 300 && distance < 5) {
                // 添加时间间隔判断，避免短时间内重复调用
                const currentTime = new Date().getTime();
                if (currentTime - lastServiceCallTime > SERVICE_CALL_INTERVAL) {
                    lastServiceCallTime = currentTime;
                    openService();
                }
            }

            // 停止拖动
            isDragging = false;
            // 移除事件监听
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('touchmove', onDrag);
            document.removeEventListener('mouseup', handleDragEnd);
            document.removeEventListener('touchend', handleDragEnd);
        };
        const {
            setFieldValue,
            submitUserData,
            fieldForm,
            resdisabled,
            openService,
            verifyStore,
            storeData,
            isRegrster,
            id,
            applyRemark
        } = makerFieldForm()
        const makerRoles = ref([])
        const roles = ref([
          { id: '1', name: '招店合作' },
          { id: '2', name: '消费推广' },
          { id: '3', name: '私密技师' },
          { id: '4', name: '店诊顾问' },
          { id: '5', name: '会销专家' },
        ])
        const scopeWork = ref([])
        const scopes = ref([
          { id: '1', name: '住家附近' },
          { id: '2', name: '本区域范围' },
          { id: '3', name: '本城市范围' },
          { id: '4', name: '本省范围' },
          { id: '5', name: '全国可出差' },
        ])

        const reference = ref([
          { id: 1, name: '我承诺所填信息真实有效，同意平台在必要时，可进行能力背景调查认证' },
        ])
        const referenceCheck = ref([])

        const workPicture = ref([])
        const workCertificate = ref([])
        const casePhoto = ref([])
        const caseVideo = ref([])
        const declaration = ref([])

        let { smsCodeText, getMsgCode, verifyMsgCode, msgCodeStatus } = useMsgCode()
        const geoCode = (address) => {
          var geocoder = new AMap.Geocoder({
            city: "",
          });
          geocoder.getLocation(address, setCode);
        }
        const setCode = (status, result) => {
          if (status === 'complete' && result.geocodes.length) {
              let location = [result.geocodes[0].location.lng, result.geocodes[0].location.lat]
              onFieldBlur('position', location)
              fieldForm.position = location
            } else {
            console.log('根据地址查询位置失败');
          }
        }

        const onFieldBlur = (key, value) => {
          if(key == 'userAddress') {
            if(value == '') {
              onFieldBlur('position', '')
              fieldForm.position = ''
            }
            geoCode(value)
          }
          if(key == 'smsCode') {
            if(value == '') {
              fieldForm.msgCodeStatus = false
              smsCode.value = value
            }
          }
          setFieldValue(key, value)
        }
        const onMakerRolesChange = (val) => {
          fieldForm.joinRole = val
          onFieldBlur('joinRole', val)
        }

        const onScopeWorkChange = (val) => {
          fieldForm.workZone = val
          onFieldBlur('workZone', val)
        }
        const toggleCheckbox = (id) => {
          let index = referenceCheck.value.findIndex(item => item == id)
          if(index == -1) {
            referenceCheck.value.push(id)
          } else {
            referenceCheck.value.splice(index, 1)
          }
          onFieldBlur('referenceCheck', referenceCheck.value)
        }

        const invitationName = ref('')
        const invitationText = ref('')
        // 删除身份证证件照正面
        const delIdCardFront = () => {
          idCardFront.value = []
          onFieldBlur('idCardFront', '')
        }
        const idCardFrontAfterUpload = (file) => {
            let form = new FormData();
            form.append("files", file.file);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                if(res.success) {
                  idCardFront.value = [
                    { url: res.data[0] }
                  ]
                  onFieldBlur('idCardFront', idCardFront.value)
                }
            })
        }
        // 删除身份证证件照反面
        const delIdCardBack = () => {
          idCardBack.value = []
          onFieldBlur('idCardBack', '')
        }
        const idCardBackAfterUpload = (file) => {
            let form = new FormData();
            form.append("files", file.file);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
                if(res.success) {
                  idCardBack.value = [
                    { url: res.data[0] }
                  ]
                  onFieldBlur('idCardBack', idCardBack.value)
                }
            })
        }
        let userImageArr = ref([])
        const delUserImage = (file, detail) => {
          let index = detail.index
          let arr = userImage.value
          arr.splice(index, 1)
          userImage.value = arr
          userImageArr.value.splice(index, 1)
          onFieldBlur('userImage', userImage.value)
        }
        const userImageAfterUpload = (file) => {
          const type = Array.isArray(file)
          let arr = []
          if (!type) {
            arr = [file.file]
          } else {
            arr = file.map((item) => item.file)
          }
          arr.forEach(item => {
            let form = new FormData();
            form.append("files", item);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
              if(res.success) {
                userImageArr.value.push({
                  url: res.data[0]
                })
                userImage.value = userImageArr.value
                onFieldBlur('userImage', userImage.value)
              }
            })
          })
        }
        let workPictureArr = ref([])
        const delworkPicture = (file, detail) => {
          let index = detail.index
          let arr = workPicture.value
          arr.splice(index, 1)
          workPicture.value = arr
          workPictureArr.value.splice(index, 1)
          onFieldBlur('workPicture', workPicture.value)
        }

        const workPictureAfterUpload = (file) => {
          const type = Array.isArray(file)
          let arr = []
          if (!type) {
            arr = [file.file]
          } else {
            arr = file.map((item) => item.file)
          }
          arr.forEach(item => {
            let form = new FormData();
            form.append("files", item);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
              if(res.success) {
                workPictureArr.value.push({
                  url: res.data[0]
                })
                workPicture.value = workPictureArr.value
                onFieldBlur('workPicture', workPicture.value)
              }
            })
          })
        }

        let workCertificateArr = ref([])
        const delworkCertificate = (file, detail) => {
          let index = detail.index
          let arr = workCertificate.value
          arr.splice(index, 1)
          workCertificate.value = arr
          workCertificateArr.value.splice(index, 1)
          onFieldBlur('workCertificate', workCertificate.value)
        }

        const workCertificateAfterUpload = (file) => {
          const type = Array.isArray(file)
          let arr = []
          if (!type) {
            arr = [file.file]
          } else {
            arr = file.map((item) => item.file)
          }
          arr.forEach(item => {
            let form = new FormData();
            form.append("files", item);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
              if(res.success) {
                workCertificateArr.value.push({
                  url: res.data[0]
                })
                workCertificate.value = workCertificateArr.value
                onFieldBlur('workCertificate', workCertificate.value)
              }
            })
          })
        }
        let casePhotoArr = ref([])
        const delcasePhoto = (file, detail) => {
          let index = detail.index
          let arr = casePhoto.value
          arr.splice(index, 1)
          casePhoto.value = arr
          casePhotoArr.value.splice(index, 1)
          onFieldBlur('casePhoto', casePhoto.value)
        }
        const casePhotoAfterUpload = (file) => {
          const type = Array.isArray(file)
          let arr = []
          if (!type) {
            arr = [file.file]
          } else {
            arr = file.map((item) => item.file)
          }
          arr.forEach(item => {
            let form = new FormData();
            form.append("files", item);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
              if(res.success) {
                casePhotoArr.value.push({
                  url: res.data[0]
                })
                casePhoto.value = casePhotoArr.value
                onFieldBlur('casePhoto', casePhoto.value)
              }
            })
          })
        }

        let caseVideoArr = ref([])
        const delCaseVideo = (file, detail) => {
          let index = detail.index
          let arr = caseVideo.value
          arr.splice(index, 1)
          caseVideo.value = arr
          caseVideoArr.value.splice(index, 1)
          onFieldBlur('caseVideo', caseVideo.value)
        }
        const caseVideoAfterUpload = (file) => {
          const type = Array.isArray(file)
          let arr = []
          if (!type) {
            arr = [file.file]
          } else {
            arr = file.map((item) => item.file)
          }
          arr.forEach(item => {
            let form = new FormData();
            form.append("files", item);
            form.append('resp', 'list')
            proxy.$http.post('/h5/upload', form, { headers: { 'content-type' : 'multipart/form-data'} }).then(({ data: res }) => {
              if(res.success) {
                caseVideoArr.value.push({
                  url: res.data[0]
                })
                caseVideo.value = caseVideoArr.value
                onFieldBlur('caseVideo', caseVideo.value)
              }
            })
          })
        }




        const flexBottom = ref(false)

        const windowHeight = ref(0)
        const getWindowResize = function () {
          windowHeight.value = window.innerHeight
        }

        const fixedBtn = computed(() => pageScrollTop.value > 350)

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', () => {})
            monitorKeyboard.value.onEnd()
        })

        function getUserMedia(constrains) {
            if (navigator.mediaDevices.getUserMedia) {
              // 最新标准API
              navigator.mediaDevices.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.webkitGetUserMedia) {
              // webkit内核浏览器
              navigator.webkitGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.mozGetUserMedia) {
              // Firefox浏览器
              navigator.mozGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            } else if (navigator.getUserMedia) {
              // 旧版API
              navigator.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
            }
        }

        function success(stream) {
          console.log("已点击允许,开启成功");
          // alert('已点击允许,开启成功')
        }
        // 异常的回调函数
        function error(error) {
          console.log("访问用户媒体设备失败：", error.name, error.message);
          // alert(`访问用户媒体设备失败,${error.name, error.message}`)
        }
        onMounted(async () => {
          window.scrollTo(0, 0)
          getWindowResize()
          window.addEventListener('resize', getWindowResize)

          // 初始化时同步数据
          idCardFront.value = fieldForm.idCardFront
          idCardBack.value = fieldForm.idCardBack
          userImage.value = fieldForm.userImage
          userImageArr.value = fieldForm.userImage
          workPicture.value = fieldForm.workPicture
          workPictureArr.value = fieldForm.workPicture
          workCertificate.value = fieldForm.workCertificate
          workCertificateArr.value = fieldForm.workCertificate
          casePhoto.value = fieldForm.casePhoto
          casePhotoArr.value = fieldForm.casePhoto
          caseVideo.value = fieldForm.caseVideo
          caseVideoArr.value = fieldForm.caseVideo
          makerRoles.value = fieldForm.joinRole ? fieldForm.joinRole : []
          scopeWork.value = fieldForm.workZone ? fieldForm.workZone : []
          referenceCheck.value = fieldForm.referenceCheck.length ? fieldForm.referenceCheck : [1]

          // 在mounted生命周期中添加事件监听
          if (dragElement.value) {
              dragElement.value.addEventListener('mousedown', startDrag);
              dragElement.value.addEventListener('touchstart', startDrag, { passive: false });
          }
        })

        // 在unmounted生命周期中移除事件监听
        onBeforeUnmount(() => {
            if (dragElement.value) {
                dragElement.value.removeEventListener('mousedown', startDrag);
                dragElement.value.removeEventListener('touchstart', startDrag);
            }
            // 确保移除所有全局事件监听
            handleDragEnd({type: 'mouseup', clientX: 0, clientY: 0});
            window.removeEventListener('scroll', () => {})
            monitorKeyboard.value.onEnd()
        })

        // 监听fieldForm变化，只更新发生变化的字段
        watch(fieldForm, (newVal, oldVal) => {
          // 只更新发生变化的字段，避免不必要的覆盖导致数据丢失
          Object.keys(newVal).forEach(key => {
            // 使用JSON.stringify比较数组/对象是否真的发生变化
            if (JSON.stringify(newVal[key]) !== JSON.stringify(oldVal[key])) {
              switch(key) {
                case 'idCardFront':
                  idCardFront.value = newVal.idCardFront
                  break
                case 'idCardBack':
                  idCardBack.value = newVal.idCardBack
                  break
                case 'userImage':
                  userImage.value = newVal.userImage
                  userImageArr.value = newVal.userImage
                  break
                case 'workPicture':
                  workPicture.value = newVal.workPicture
                  workPictureArr.value = newVal.workPicture
                  break
                case 'workCertificate':
                  workCertificate.value = newVal.workCertificate
                  workCertificateArr.value = newVal.workCertificate
                  break
                case 'casePhoto':
                  casePhoto.value = newVal.casePhoto
                  casePhotoArr.value = newVal.casePhoto
                  break
                case 'caseVideo':
                  caseVideo.value = newVal.caseVideo
                  caseVideoArr.value = newVal.caseVideo
                  break
                case 'joinRole':
                  makerRoles.value = newVal.joinRole || []
                  break
                case 'workZone':
                  scopeWork.value = newVal.workZone || []
                  break
                case 'referenceCheck':
                  referenceCheck.value = newVal.referenceCheck || []
                  break
              }
            }
          })
        }, {deep: true})



        // 获取验证码    /store_settled/code
        const time = ref(60)
        let timer = ''
        const getCode = (type) => {
            let re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;

            if(1 == type) {
                if('' == regesterPhone.value) {
                    proxy.$toast.fail('请填写手机号');
                    return
                }
                let result = re.test(regesterPhone.value);
                if(!result) {
                    proxy.$toast.fail('请填写正确格式的手机号码');
                    return ;
                }
            }
            if( 2 == type) {
                if('' == mePhone.value) {
                    proxy.$toast.fail('请填写手机号');
                    return
                }
                let result = re.test(mePhone.value);
                if(!result) {
                    proxy.$toast.fail('请填写正确格式的手机号码');
                    return ;
                }
            }
            isSubSms.value = true
            proxy.$http.post('/store_settled/code', { phone: 1 == type ? regesterPhone.value : mePhone.value }).then(({ data: res }) => {
                if(res.success && res.data.status == 2) {
                    settleStatus.value = true
                    setTimeout(() => {
                        $router.push({ path: "/downapk" });
                    }, 2000)
                    return
                }

                if(res.success) {
                    proxy.$toast.success('验证码已发送');
                    let num = time.value
                    timer = setInterval(() => {
                        if(num > 0) {
                            num--
                            regesterText.value = num + 's'
                            time.value = num
                        } else {
                            regesterText.value = '重新获取'
                            time.value = 60
                            isSubSms.value = false
                            clearInterval(timer)
                        }
                    }, 1000)
                } else {
                    setTimeout(() => {
                        isSubSms.value = false
                        regesterText.value = '获取验证码'
                    })
                    proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const settleStatus = ref(false)
        const editPopup = ref(false)

        const mePhone = ref('')
        const meCode = ref('')

        const editBtn = () => {
            if('' == mePhone.value) {
              proxy.$toast.fail('请填写手机号');
              return
            }
            if('' == meCode.value) {
              proxy.$toast.fail('请填写验证码');
              return
            }
            editAbled.value = true
            proxy.$toast.loading({
              message: '修改中',
              duration: 1500,
            })
            proxy.$http.post('/store_settled/login', { phone: mePhone.value, code: meCode.value }).then(({ data: res }) => {
                editAbled.value = false
                if(res.success) {
                    if(2 == res.data.status && res.data.status) {
                      setTimeout(() => {
                        settleStatus.value = true
                      }, 1000)
                    } else {
                      setTimeout(() => {
                        editPopup.value = false
                        bossPhone.value = mePhone.value
                        regesterCode.value = meCode.value
                      }, 1000)
                    }
                } else {
                  proxy.$toast.fail(res.errorMessage);
                }
            })
        }

        const getMapInfo = (map) => {
          if(!map.fullAddress) {
            showMap.value = false
            return
          }
          onFieldBlur('userAddress', map.fullAddress)
          onFieldBlur('position', map.position.join(','))
          showMap.value = false
          fieldForm.userAddress = map.fullAddress
        }

        const onShowMap = () => {
          showMap.value = true
        }

        return {
          isRegrster,
          fieldForm,
          smsCode,
          phone,
          address,
          successImg,
          regesterText,
          flexBottom,
          settleList,
          isSubSms,
          settleStatus,
          invitationName,
          invitationText,
          editPopup,
          mePhone,
          meCode,
          resdisabled,
          editAbled,
          isWX,
          smsCodeText,
          msgCodeStatus,
          imgUrl,
          fixedBtn,
          openService,
          verifyStore,
          storeData,
          showMap,
          verifyMsgCode,
          submitUserData,
          idCardFrontAfterUpload,
          getCode,
          editBtn,
          onFieldBlur,
          getMsgCode,
          delIdCardFront,
          getMapInfo,
          onShowMap,
          idCardFront,
          idCardBack,
          delIdCardBack,
          idCardBackAfterUpload,
          userImage,
          delUserImage,
          userImageAfterUpload,
          makerRoles,
          roles,
          scopeWork,
          scopes,
          workPicture,
          delworkPicture,
          workPictureAfterUpload,
          workCertificate,
          delworkCertificate,
          workCertificateAfterUpload,
          casePhoto,
          delcasePhoto,
          casePhotoAfterUpload,
          caseVideo,
          delCaseVideo,
          caseVideoAfterUpload,
          declaration,
          reference,
          referenceCheck,
          id,
          applyRemark,
          toggleCheckbox,
          onMakerRolesChange,
          onScopeWorkChange,
          dragElement,
          dragStyle,
          startDrag,
          handleDragEnd
        }
    },
  }




</script>

<style scoped lang="scss" src="./index.scss"></style>
















